import $ from "jquery";
import CONFIG from "@bd-core/config";
import Storage from "@bd-utils/storage";
import GameLogic from "@bd-core/game-logic";
import { currentPageIsMainRoom, getCurrentPageId } from "@bd-stores/user-progress";

export default class ReportingPopup {
    constructor() {
        this.elms = {
            popup: ".js-reporting-popup",
            option: ".js-reporting-option",
            submitBtn: ".js-reporting-submit",
            feedback: ".js-reporting-feedback",
            feedbackBtn: ".js-reporting-feedback-btn",
            popupTimer: ".js-reporting-timer",
        };

        return this;
    }

    init() {
        //
    }

    _setHasSeen(roomId) {
        let states = Storage.get("states", {});
        if (!states?.reporting) states.reporting = [];
        states.reporting.push(roomId);
        return Storage.set("states", states);
    }

    _getHasSeen(roomId) {
        let states = Storage.get("states", {});
        return states?.reporting && states.reporting.includes(roomId);
    }

    show(roomId) {
        const elms = this.elms;
        const currentPageId = getCurrentPageId();
        const hasSeen = this._getHasSeen(roomId);
        const isCurrentPageMainroom = currentPageIsMainRoom();
        
        if(roomId !== currentPageId) return;

        if(hasSeen) return;

        if (hasSeen && isCurrentPageMainroom) return;

        const rooms = CONFIG?.game?.rooms || false;
        if (!Array.isArray(rooms) || !rooms.length) return;

        const room = rooms.find((r) => r?.id == roomId);
        const room_type = room?.room?.room_type;
        // @ts-ignore
        const hint_risk = room?.room?.hints?.hint_risk || false;
        let hint_risk_part2 = "";

        if(room_type === "match_card") {
            // @ts-ignore
            const hints_puzzle_part_2 = room?.room?.puzzle_part_2?.toby_hint;
            hint_risk_part2 = hints_puzzle_part_2?.hint_risk_level;
        }

        if(hint_risk !== "high") {
            if(hint_risk_part2 !== "high") {
                return;
            }
        }

        const $popup = $(".js-reporting-popup");

        $popup.addClass("is-open");
        this.handleTimer(roomId);

        $popup.find(elms.submitBtn).on("click", () =>{
            this.goToFeedback(roomId);
        });

       $(elms.option).on("change", (e) => {
            this.onSelectOption(e);
        });

        if(!hasSeen) this._setHasSeen(roomId);
    }

    onSelectOption(e) {
        const elms = this.elms;
        const $options = $(elms.option);
        const $this = $(e.currentTarget);

        $.each($options, (index, value) => {
            const $option = $(value);
            $option.prop("checked", false);
            $option.parent().removeClass("is-wrong");
        });

        $this.prop("checked", true);
    }

    goToFeedback(roomId) {
        const rooms = CONFIG?.game?.rooms || false;
        if (!Array.isArray(rooms) || !rooms.length) return;

        const room = rooms.find((r) => r?.id == roomId);
        // @ts-ignore
        const {reporting} = room?.room || {};
        const {answer_options, question_txt} = reporting;
        const hasQuestion = question_txt !== "";

        const elms = this.elms;
        const $popup = $(elms.popup);

        if(hasQuestion) {
            const $selectedOption = $(`${elms.option}:checked`);
            const selectedOptionVal = $selectedOption.val();
    
            let isOptionCorrect = false;
            $.each(answer_options, (index, value) => {
                const {option_id, is_correct_answer} = value;
    
                if(option_id == selectedOptionVal && is_correct_answer) {
                    isOptionCorrect = true;
                }
            });
    
            let statusClass = "is-wrong";
            if(isOptionCorrect) {
                statusClass = "is-correct";
                
                setTimeout(() => {
                    $popup.addClass("is-feedback");
                }, 2500);
            }
    
            $selectedOption
            .parent()
            .removeClass("is-wrong is-correct")
            .addClass(statusClass);
        } else {
            $popup.addClass("is-feedback");
        }

        $(elms.feedbackBtn).on("click", () => {
            this.hide();
            GameLogic.openCompletionPopup();
        });
    }

    hide() {
        const $popup = $(this.elms.popup);
        $popup.removeClass("is-open");
    }

    handleTimer(roomId) {
        const self = this;
        const rooms = CONFIG?.game?.rooms || false;
        if (!Array.isArray(rooms) || !rooms.length) return;

        const room = rooms.find((r) => r?.id == roomId);
        // @ts-ignore
        const {reporting} = room?.room || {};
        const {timer} = reporting;

        const elms = this.elms;
        const $timer = $(elms.popupTimer);
        const $feedbackBtn = $(elms.feedbackBtn);

        if(timer === 0){
            $feedbackBtn.prop("disabled", false);
            return;
        }

        const toTimeObject = (time) => {
            const minutes = Math.floor((time / 1000 / 60) % 60);
            const seconds = Math.floor((time / 1000) % 60);

            return {
                m: minutes.toString().padStart(2, "0"),
                s: seconds.toString().padStart(2, "0"),
            };
        };

        const updateTimerTxt = (m,s) => {
            const txt = `${m}:${s}`;
            $timer.find('span').html(txt);
        };

        const getCurrentTime = () => new Date(Date.now()).getTime();
        const timeLimit = new Date(
            getCurrentTime() + timer * 1000,
        );
        // const timeLeft = timeLimit.getTime() - getCurrentTime();

        this.reportingTimer = setInterval(() => {
            const time = timeLimit.getTime() - getCurrentTime();
            const objTimer = toTimeObject(time);

            updateTimerTxt(objTimer.m, objTimer.s);

            if(time <= 0){
                updateTimerTxt("00", "00");

                if(self.reportingTimer) {
                    clearInterval(self.reportingTimer);
                    $feedbackBtn.prop("disabled", false);
                }
            }
        }, 1000);

        // Perform timer calculation immediately before the interval
        const time = timeLimit.getTime() - getCurrentTime();
        const objTimer = toTimeObject(time);
        updateTimerTxt(objTimer.m, objTimer.s);
    }
}